module.exports = __webpack_public_path__ + "img/07.576ff2c6.jpg";